"use client";

import { c as _c } from "react/compiler-runtime";
import { useRef } from "react";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import CreateWaveGroupSearchInput from "./CreateWaveGroupSearchInput";
import CreateWaveGroupSearchResults from "./CreateWaveGroupSearchResults";
import { useCreateWaveGroupSearch } from "./useCreateWaveGroupSearch";
export default function CreateWaveGroupSearchField(t0) {
  const $ = _c(42);
  const {
    label,
    defaultLabel,
    disabled,
    selectedGroup,
    allowClear: t1,
    onSelect
  } = t0;
  const allowClear = t1 === undefined ? true : t1;
  const inputRef = useRef(null);
  const wrapperRef = useRef(null);
  let t2;
  if ($[0] !== allowClear || $[1] !== defaultLabel || $[2] !== disabled || $[3] !== onSelect || $[4] !== selectedGroup) {
    t2 = {
      defaultLabel,
      disabled,
      inputRef,
      selectedGroup,
      allowClear,
      onSelect,
      wrapperRef
    };
    $[0] = allowClear;
    $[1] = defaultLabel;
    $[2] = disabled;
    $[3] = onSelect;
    $[4] = selectedGroup;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const search = useCreateWaveGroupSearch(t2);
  const t3 = !!selectedGroup;
  let t4;
  if ($[6] !== disabled || $[7] !== label || $[8] !== search.activeOptionId || $[9] !== search.clearSelection || $[10] !== search.handleInputChange || $[11] !== search.handleKeyDown || $[12] !== search.hasValue || $[13] !== search.inputId || $[14] !== search.inputValue || $[15] !== search.isOpen || $[16] !== search.listboxId || $[17] !== search.onInputFocus || $[18] !== search.showClearButton || $[19] !== t3) {
    t4 = <CreateWaveGroupSearchInput inputRef={inputRef} inputId={search.inputId} listboxId={search.listboxId} activeOptionId={search.activeOptionId} label={label} value={search.inputValue} isOpen={search.isOpen} disabled={disabled} hasValue={search.hasValue} hasSelectedGroup={t3} showClearButton={search.showClearButton} onInputFocus={search.onInputFocus} onInputChange={search.handleInputChange} onInputKeyDown={search.handleKeyDown} onClearSelection={search.clearSelection} />;
    $[6] = disabled;
    $[7] = label;
    $[8] = search.activeOptionId;
    $[9] = search.clearSelection;
    $[10] = search.handleInputChange;
    $[11] = search.handleKeyDown;
    $[12] = search.hasValue;
    $[13] = search.inputId;
    $[14] = search.inputValue;
    $[15] = search.isOpen;
    $[16] = search.listboxId;
    $[17] = search.onInputFocus;
    $[18] = search.showClearButton;
    $[19] = t3;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  let t5;
  if ($[21] !== disabled || $[22] !== search.activeIndex || $[23] !== search.helperText || $[24] !== search.isFetching || $[25] !== search.isOpen || $[26] !== search.listboxId || $[27] !== search.onOptionSelect || $[28] !== search.searchCriteria || $[29] !== search.setActiveIndex || $[30] !== search.showNoResults || $[31] !== search.suggestions || $[32] !== selectedGroup) {
    t5 = <CreateWaveGroupSearchResults isOpen={search.isOpen} disabled={disabled} listboxId={search.listboxId} isFetching={search.isFetching} suggestions={search.suggestions} selectedGroup={selectedGroup} activeIndex={search.activeIndex} searchCriteria={search.searchCriteria} showNoResults={search.showNoResults} helperText={search.helperText} onActiveIndexChange={search.setActiveIndex} onOptionSelect={search.onOptionSelect} />;
    $[21] = disabled;
    $[22] = search.activeIndex;
    $[23] = search.helperText;
    $[24] = search.isFetching;
    $[25] = search.isOpen;
    $[26] = search.listboxId;
    $[27] = search.onOptionSelect;
    $[28] = search.searchCriteria;
    $[29] = search.setActiveIndex;
    $[30] = search.showNoResults;
    $[31] = search.suggestions;
    $[32] = selectedGroup;
    $[33] = t5;
  } else {
    t5 = $[33];
  }
  let t6;
  if ($[34] !== t4 || $[35] !== t5) {
    t6 = <div className="tw-group tw-relative tw-w-full">{t4}{t5}</div>;
    $[34] = t4;
    $[35] = t5;
    $[36] = t6;
  } else {
    t6 = $[36];
  }
  let t7;
  if ($[37] !== search.helperText) {
    t7 = <p className="tw-mb-0 tw-text-xs tw-font-medium tw-text-iron-400">{search.helperText}</p>;
    $[37] = search.helperText;
    $[38] = t7;
  } else {
    t7 = $[38];
  }
  let t8;
  if ($[39] !== t6 || $[40] !== t7) {
    t8 = <div className="tw-flex tw-flex-col tw-gap-y-2" ref={wrapperRef}>{t6}{t7}</div>;
    $[39] = t6;
    $[40] = t7;
    $[41] = t8;
  } else {
    t8 = $[41];
  }
  return t8;
}